document.querySelectorAll('[data-slideshow]').forEach(function(el){const slides=[...el.querySelectorAll('.hero-slide')],dots=[...el.querySelectorAll('.hero-dot')];if(slides.length<2)return;let n=0;function show(i){slides.forEach((s,k)=>s.classList.toggle('active',k===i));dots.forEach((d,k)=>d.classList.toggle('active',k===i));n=i;}dots.forEach((d,i)=>d.addEventListener('click',()=>show(i)));if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches)setInterval(()=>show((n+1)%slides.length),5500);});
document.addEventListener('click', async function(event) {
  const button = event.target.closest('[data-buy-now]');
  if (!button || button.disabled) return;
  const form = button.closest('form');
  if (!form) return;
  event.preventDefault();
  const variant = form.querySelector('[name="id"]');
  const quantityInput = form.querySelector('[name="quantity"]');
  const quantity = Math.max(1, Number(quantityInput ? quantityInput.value : 1) || 1);
  if (!variant || !variant.value) return;
  button.disabled = true;
  const previous = button.textContent;
  button.textContent = 'Please wait…';
  const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  try {
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:Number(variant.value),quantity:quantity}]})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Unable to add item');
    window.location.assign(root + 'checkout');
  } catch (error) {
    button.disabled = false;
    button.textContent = previous;
    let status = form.querySelector('[data-purchase-error]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-purchase-error','');
      status.setAttribute('role','alert');
      form.appendChild(status);
    }
    status.textContent = error.message || 'Please try again.';
  }
});
